import { useMemo } from 'react'
import { useDataValue } from 'Simple/Data.js'

let CBS_XID = 'c5b41'
let CBS_EXCLUDE_QUESTIONS = ['cbswelcome', 'imagecapture']

export default function useDataTransform(props, data) {
  let questions = useDataValue({
    context: 'questions',
    viewPath: props.viewPath,
  })

  let selected_configuration_level = useDataValue({
    context: 'selected',
    path: 'configuration_level',
    viewPath: props.viewPath,
  })

  let xid = useDataValue({
    context: 'global',
    path: 'currrent_location.xid',
    viewPath: props.viewPath,
  })

  return useMemo(() => {
    if (!data) return data

    let existingQuestionTemplates = getExistingQuestions({
      questions,
      resource_table: 'question_templates',
      resource_schema: 'leads',
    })

    let existingMedicalFormQuestions = getExistingQuestions({
      questions,
      resource_table: 'questions',
      resource_schema: 'medical_histories',
    })

    return [
      { id: 'custom', text: 'Custom Question' },
      { id: 'break-profile', text: '-- Profile / Appointment Questions --' },
      // Filter out existing questions and, if applicable, CBS questions in one pass
      ...(data.leads_question_templates
        .filter(
          question =>
            !existingQuestionTemplates.includes(question.id) &&
            (xid === CBS_XID || !CBS_EXCLUDE_QUESTIONS.includes(question.id))
        )
        .map(question => {
          return {
            ...question,
            resource_id: question.id,
            resource_table: 'question_templates',
            resource_schema: 'leads',
            type: 'external',
          }
        }) || { id: 'break-profile-none', text: 'All questions configured' }),
      { id: 'break-medical', text: '-- Medical Questions --' },
      // Filter out existing questions
      ...((selected_configuration_level === 'location' &&
        data.medical_histories_questions
          .filter(
            question => !existingMedicalFormQuestions.includes(question.id)
          )
          .map(question => {
            return {
              ...question,
              resource_id: question.id,
              resource_table: 'questions',
              resource_schema: 'medical_histories',
              type: 'external',
            }
          })) || [
        { id: 'break-no-medical', text: 'Not Available for a division app' },
      ]),
    ]
  }, [data, selected_configuration_level, questions, xid])
}

function getExistingQuestions({ questions, resource_table, resource_schema }) {
  return questions
    .filter(
      question =>
        question.resource_table === resource_table &&
        question.resource_schema === resource_schema
    )
    .map(question => question.resource_id)
}
